// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__OkYgX","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2jEs6","obliqueLine":"membershipbadge_obliqueLine__3F2v3"};